<template>
  <v-menu
    offset-y
    origin="center center"
    :nudge-bottom="10"
    transition="scale-transition"
    :close-on-content-click="false"
  >
    <template v-slot:activator="{on}">
      <v-btn
        data-cy="profileMenuBtn"
        icon
        large
        v-on="on"
      >
        <v-avatar size="36px">
          <v-icon
            x-large
            class="blue--text"
          >
            account_circle
          </v-icon>
        </v-avatar>
      </v-btn>
    </template>
    <v-list class="pa-0">
      <v-list-item>
        <v-list-item-avatar>
          <v-icon x-large class="blue--text">
            account_circle
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{tokenData ? tokenData.name : null}}</v-list-item-title>
          <v-list-item-subtitle>{{tokenData ? tokenData.email: null}}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider/>
      <v-list-item data-cy="logoutBtn" @click="logout">
        <v-list-item-avatar>
          <v-icon>
            logout
          </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Logout</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';
  import { NOTIFICATION_ERROR } from '@/common/event.types';
  import * as routeConstants from '@/router/constants';
  import * as actions from '@/store/actions.type';

  export default {
    name: 'AppProfile',
    computed: {
      ...mapGetters([
        'tokenData'
      ]),
    },
    methods: {
      ...mapActions({
        logoutAction: actions.LOGOUT,
      }),
      logout() {
        this.logoutAction().then(() => {
          this.$router.push(routeConstants.LOGIN_URL);
        }).catch(({data}) => {
          this.$eventHub.$emit(NOTIFICATION_ERROR, {
            message: data,
          });
        });
      },
    },
  };
</script>

<style scoped>

</style>